var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitDetailsPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_2188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.484 3.51344C15.797 -1.17214 8.19902 -1.17101 3.51344 3.51602C-1.17214 8.20305 -1.17101 15.801 3.51602 20.4866C8.20305 25.1722 15.801 25.171 20.4866 20.484C22.7369 18.233 24.0007 15.1803 24 11.9974C23.9994 8.8151 22.7346 5.76335 20.484 3.51344ZM18.1736 16.7159C18.1731 16.7164 18.1726 16.717 18.172 16.7175V16.7135L17.564 17.3175C16.7777 18.1137 15.6325 18.4413 14.544 18.1815C13.4473 17.8879 12.4048 17.4207 11.456 16.7975C10.5745 16.2341 9.75752 15.5755 9.01999 14.8335C8.34138 14.1598 7.73172 13.4201 7.19997 12.6255C6.61835 11.7704 6.15799 10.8389 5.83197 9.85746C5.45824 8.70452 5.76794 7.43941 6.63199 6.58947L7.34397 5.87749C7.54192 5.67864 7.86358 5.67794 8.06238 5.87589C8.06289 5.87641 8.06346 5.87692 8.06397 5.87749L10.312 8.12547C10.5108 8.32342 10.5115 8.64508 10.3135 8.84388C10.313 8.84439 10.3125 8.84491 10.312 8.84547L8.99196 10.1655C8.61321 10.5401 8.56558 11.1354 8.87997 11.5655C9.35739 12.2207 9.88572 12.8373 10.46 13.4095C11.1003 14.0525 11.7963 14.6375 12.54 15.1575C12.9697 15.4572 13.5522 15.4067 13.924 15.0375L15.1999 13.7415C15.3979 13.5427 15.7195 13.542 15.9183 13.7399C15.9189 13.7404 15.9194 13.741 15.9199 13.7415L18.172 15.9975C18.3708 16.1954 18.3715 16.517 18.1736 16.7159Z",
    fill: "#4D4949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_2188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitDetailsPhoneIcon);
export default __webpack_public_path__ + "static/media/unit-details-phone-icon.90a4ac6b9d7bd957784a000cb5ba4be8.svg";
export { ForwardRef as ReactComponent };